import { API_URL, CUSTOMERS_KEY } from '../keys'
import axios from 'axios'

export const fetchCategories = async () => {
	const response = await axios.get(`${API_URL}/categories/shop`, {
		headers: {
			'sce-api-key': CUSTOMERS_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}
